import { Button, SxProps, Theme } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
  startIcon?: React.ReactNode;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit' | undefined;
  variant?: 'text' | 'outlined' | 'contained';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  href?: string;
  sx?: SxProps<Theme>;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function FSPrimaryButton({
  children,
  startIcon,
  disabled = false,
  type,
  variant = 'contained',
  color = 'secondary',
  href,
  sx,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: IProps) {
  return (
    <Button
      variant={variant}
      disabled={disabled}
      sx={{
        borderRadius: '100px',
        textTransform: 'none',
        paddingRight: '20px',
        paddingLeft: '20px',
        fontSize: '14px',
        height: '40px',
        fontWeight: 'bold',
        ...sx,
      }}
      startIcon={startIcon}
      type={type || 'button'}
      color={color}
      href={href}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Button>
  );
}
